<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Try Sentiment Model
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs4>
                <v-select
                dense
                label="Data Source"
                :items="dataSourcesCollection"
                v-model="dataSource"
                >
                </v-select>
              </v-flex>
              <v-flex xs4 v-if="dataSource == 2">
                <v-select
                label="Dataset"
                :items="datasets"
                v-validate="'required'"
                data-vv-name="dataset"
                :error-messages="errors.collect('dataset')"
                v-model="dataset">
                </v-select>              </v-flex>
              <v-flex xs4 v-if="dataSource == 2">
                <v-text-field
                v-model.number="randomDataCount"
                label="Random Data Count"
                type="number"
                v-validate="'required|integer'"
                data-vv-name="data count"
                :error-messages="errors.collect('data count')"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row v-if="dataSource == 1">
              <v-flex xs12>
                <v-textarea
                  label="Text to analyse"
                  v-validate="'required'"
                  data-vv-name="text"
                  :error-messages="errors.collect('text')"
                  v-model="text"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="analyseLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(analyse)" :loading="analyseLoading" :disabled="analyseLoading">Try</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap v-if="analyseResults && analyseResults.length > 0" v-for="(analyseResult, j) in analyseResults" :key="j">
    <v-flex>
      <v-card>
        <v-card-title primary-title class="headline">
          Result - {{ j }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout row>
              <v-flex xs6>
                <h4>Text</h4>
                <span
                v-for="(token, i) in analyseResult.tokens"
                :key="i">
                <template v-if="token.attention && token.attention > 0.1">
                  <v-tooltip
                  top>
                    <v-chip
                      slot="activator"
                      dark
                      text-color="white"
                      class="v-chip--select-multi"
                      :color="`indigo${token.attention.toFixed(1) == 0.5 ? '' : (token.attention > 0.5 ? ` darken-${((token.attention.toFixed(1) - 0.5) * 10).toFixed(0)}` : ` lighten-${((0.5 - token.attention.toFixed(1)) * 10).toFixed(0)}`)}` "
                      small
                    >
                      {{ token.token }}
                    </v-chip>
                    <span><b>Attention: </b>{{token.attention}}</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  {{token.token}}
                </template>
                </span>
              </v-flex>
              <v-flex xs3 offset-xs1>
                <h4>Score</h4>
                <v-flex class="text-xs-center">
                  <v-progress-circular
                  v-if="analyseResult.score && analyseResult.score.overall"
                  :rotate="-90"
                  color="accent"
                  slot="activator"
                  :size="75"
                  :width="5"
                  :value="analyseResult.score.overall * 100">
                    {{(analyseResult.score.overall * 100).toFixed(2)}}%
                  </v-progress-circular>
                  <v-progress-circular
                  v-else
                  v-for="(segment, i) in Object.keys(analyseResult.score.segmented)"
                  :key="i"
                  :color="segment"
                  slot="activator"
                  :rotate="-90"
                  :size="75"
                  :width="5"
                  :value="analyseResult.score.segmented[segment] * 100">
                    <v-tooltip bottom :color="segment">
                      <div slot="activator">
                        {{(analyseResult.score.segmented[segment] * 100).toFixed(2)}}%
                      </div>
                      {{ segment }}
                    </v-tooltip>
                  </v-progress-circular>
                </v-flex>
              </v-flex>
              <v-flex xs2 v-if="analyseResult.confidence">
                <h4>Confidence</h4>
                <v-flex class="text-xs-center">
                  <v-progress-circular
                  color="accent"
                  slot="activator"
                  :rotate="-90"
                  :size="75"
                  :width="5"
                  v-model="analyseResult.confidencePercent">
                    {{analyseResult.confidencePercent.toFixed(2)}}%
                  </v-progress-circular>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created () {
    this.axios.get(`/datasets`)
      .then(response => {
        this.datasets = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
  },
  data () {
    return {
      dataSourcesCollection: [
        {
          value: 1,
          text: 'Manual Entry'
        },
        {
          value: 2,
          text: 'Dataset'
        }
      ],
      dataset: undefined,
      datasets: [],
      text: '',
      analyseLoading: false,
      analyseResults: null,
      dataSource: 1,
      randomDataCount: 10
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    analyse () {
      this.analyseLoading = true
      this.analyseResults = []
      const texts = this.text.split('\n')
      this.axios.post(`/sentiment-models/${this.id}/try`, {texts: texts, random_data_count: this.randomDataCount, data_source: this.dataSource, dataset: this.dataset})
        .then(response => {
          this.analyseResults = response.data.map((data) => {
            return {
              htmlText: data.html_text,
              confidence: data.confidence,
              confidencePercent: data.confidence * 100,
              text: data.text,
              score: data.score,
              tokens: data.tokens
            }
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.analyseLoading = false
        })
    }
  }
}
</script>

<style>
.v-progress-circular {
  margin: 1rem
}
</style>
